module.exports = __webpack_public_path__ + "img/reports_list.dc605504.svg";